import config from "./config.js";
import globalState from "./globalState.js";
import orchestratorFactory from "./orchestratorFactory.js";

(() => {
	const orchestrator = orchestratorFactory(config, globalState);
	orchestrator.init();
})();
